'use strict';

angular.module('TurneroApp').component('coTurnos', {
    bindings: {
        centroAtencionSeleccionadoBinding: '<',
        supervisor: '<',
        esTelefonico: '<',
        ctrlPadre: '='
    },
    controller: [
        '$scope',
        '$rootScope',
        '$window',
        'turnosService',
        'utilsService',
        'motivosService',
        'TurneroAppConstant',
        '$location',
        '$localStorage',
        '$anchorScroll',
        '$mdDialog',
        '$rootElement',
        'signalrDotNetCoreService',
        function ($scope, $rootScope, $window, turnosService, utilsService, motivosService, TurneroAppConstant, $location, $localStorage, $anchorScroll,
            $mdDialog,
            $rootElement,
            signalrService) {
            var ctrl = this;

            ctrl.rowSelection = true;
            ctrl.multiSelect = true;
            ctrl.autoSelect = true;
            ctrl.datosFiltroInfo = null;
            ctrl.fechas = null;
            ctrl.disabledCancelar = true;
            ctrl.disabledEnviar = true;
            ctrl.disabledReagendar = true
            ctrl.disabledCambioEstado = true;
            ctrl.CancelarTurnos = {};
            ctrl.turnosSeleccionados = [];
            $localStorage.TurneroApp_ListadoImprimir = null;
            ctrl.Estados = TurneroAppConstant.Estados.Turno;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.Modalidades = TurneroAppConstant.Modalidades;
            ctrl.ModalidadesArray = TurneroAppConstant.ModalidadesArray;
            var date = new Date();
            ctrl.fechas = date.toString('dd/MM/yyyy');

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                order: 'name',
                limit: 10,
                page: 1
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.errores = {
                cuil: false,
                roles: false,
            };

            ctrl.mostrarColumnaPatente = function () {
                return ctrl.turnos && ctrl.turnos.some(function (t) { return t.Solicita_Patente === 'S'; });
            };

            $scope.$on('limpiarResultados', function (event, data) {
                // you could inspect the data to see if what you care about changed, or just update your own scope
                ctrl.turnos = null;
                ctrl.pagination.total = null;
                swal.close();
            });

            $scope.$on('aplicarFiltros', function (event, data) {
                // you could inspect the data to see if what you care about changed, or just update your own scope
                ctrl.centroAtencionSeleccionado = ctrl.centroAtencionSeleccionadoBinding ? ctrl.centroAtencionSeleccionadoBinding : data.centroAtencion;
                ctrl.datosFiltroInfo = data;
                ctrl.aplicarFiltros(data);
                ctrl.ctrlPadre.ctrlTurnosListado = ctrl;
            });


            $scope.$on('buscarPorId', function (event, data) {
                // you could inspect the data to see if what you care about changed, or just update your own scope
                ctrl.centroAtencionSeleccionado = ctrl.centroAtencionSeleccionadoBinding ? ctrl.centroAtencionSeleccionadoBinding : data.centroAtencion;
                ctrl.datosFiltroInfo = data;
                ctrl.buscarIdTurno(data);
            });

            ctrl.onPaginate = function () {

                ctrl.turnosSeleccionados = [];

                $location.hash('tabla-turnos');
                $anchorScroll();
                ctrl.grillaReload();
            }

            ctrl.selectItem = function (item) {
                if (ctrl.turnosSeleccionados.length > 1 && !ctrl.supervisor) {
                    for (var i = 0; i < ctrl.turnosSeleccionados.length; i++) {
                        if (ctrl.turnosSeleccionados[i].Id_Turno == item.Id_Turno) {
                            ctrl.turnosSeleccionados.splice(i, 1);
                            break;
                        }
                    }
                }
                validarBoton();
                validarBotonEnviar();
                validarBotonEstadoFinal();
                validarBotonReagendar();
            };

            ctrl.deselectItem = function (item) {
                validarBoton();
                validarBotonEnviar();
                validarBotonEstadoFinal();
                validarBotonReagendar();
            };

            function validarBoton() {

                angular.forEach(ctrl.turnosSeleccionados, function (obj, id) {

                    //valido que el objeto este seleccionado y no tenga false en el contenido
                    if (obj != false) {
                        //valido el estado, si no fuese Agendado/Reagendado/Requiere_Reagendado, no se debe habilitar el boton cancelar.
                        if (obj.Id_Estado != ctrl.Estados.Agendado && obj.Id_Estado != ctrl.Estados.Reagendado && obj.Id_Estado != ctrl.Estados.Requiere_reagendado) {
                            ctrl.disabledCancelar = true;
                        }
                        else {
                            ctrl.disabledCancelar = false;
                        }
                    };

                });

                if (ctrl.turnosSeleccionados.length == 0) {
                    ctrl.disabledCancelar = true;
                }
            }
            function validarBotonEstadoFinal() {

                angular.forEach(ctrl.turnosSeleccionados, function (obj, id) {

                    //valido que el objeto este seleccionado y no tenga false en el contenido
                    if (obj != false) {
                        //valido el estado, si no fuese Agendado/Reagendado/Requiere_Reagendado, no se debe habilitar el boton cancelar.
                        if (obj.Id_Estado == ctrl.Estados.Cancelado || obj.Id_Estado == ctrl.Estados.Finalizado) {
                            ctrl.disabledCambioEstado = true;
                            return;
                        }
                        else {
                            ctrl.disabledCambioEstado = false;
                        }
                    };

                });

                if (ctrl.turnosSeleccionados.length == 0) {
                    ctrl.disabledCambioEstado = true;
                }
            }

            function validarBotonEnviar() {
                var OldObj = {}
                angular.forEach(ctrl.turnosSeleccionados, function (obj, id) {

                    //valido que el objeto este seleccionado y no tenga false en el contenido
                    if (obj) {
                        //valido el estado, si no fuese Agendado/Reagendado/Requiere_Reagendado, no se debe habilitar el boton cancelar.
                        if (OldObj.Id_Agenda && (obj.Id_Agenda != OldObj.Id_Agenda || obj.Id_Estado != OldObj.Id_Estado)) {
                            ctrl.disabledEnviar = true;
                        }
                        else {
                            OldObj = obj;
                            ctrl.disabledEnviar = false;
                        }
                    };

                });

                if (ctrl.turnosSeleccionados.length == 0) {
                    ctrl.disabledEnviar = true;
                }
            }
            function validarBotonReagendar() {
                var OldObj = {}
                if (ctrl.turnosSeleccionados.length == 0) {
                    ctrl.disabledReagendar = true;
                } else {
                    for (var i = 0; i < ctrl.turnosSeleccionados.length; i++) {
                        var obj = ctrl.turnosSeleccionados[i];
                        if (obj.Id_Estado != ctrl.Estados.Agendado && obj.Id_Estado != ctrl.Estados.Requiere_reagendado) {
                            ctrl.disabledReagendar = true;
                            break;
                        } else {
                            if (OldObj.Id_Agenda && (obj.Id_Agenda != OldObj.Id_Agenda || obj.Id_Modalidad == ctrl.Modalidades.Orden_de_Llegada)) {
                                ctrl.disabledReagendar = true;
                                break;
                            } else {
                                OldObj = obj;
                                ctrl.disabledReagendar = false;
                            }
                        }
                    }
                }

            }

            ctrl.grillaReload = function () {


                if (ctrl.datosFiltroInfo != null) {
                    if (ctrl.datosFiltroInfo.Id_Turno != undefined && ctrl.datosFiltroInfo.Id_Turno.length > 0) {
                        ctrl.buscarIdTurno(ctrl.datosFiltroInfo)
                    } else {
                        ctrl.aplicarFiltros(ctrl.datosFiltroInfo);
                    }
                };

            };

            ctrl.aplicarFiltros = function (item) {
                if (item.Fec_Desde != null && item.Fec_Hasta != null) {

                    var fec_des = moment(item.Fec_Desde).toDate();
                    var fec_has = moment(item.Fec_Hasta).toDate();

                    if (fec_des === fec_has) {
                        ctrl.fechas = (fec_des.getDate() + '/' + (fec_des.getMonth() + 1) + '/' + fec_des.getFullYear()).toString();
                    }
                    else {
                        ctrl.fechas = (fec_des.getDate() + '/' + (fec_des.getMonth() + 1) + '/' + fec_des.getFullYear()).toString() + ' al ' + (fec_has.getDate() + '/' + (fec_has.getMonth() + 1) + '/' + fec_has.getFullYear()).toString();
                    }
                    ctrl.BuscarporId = false;
                    ctrl.getData(item, ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);

                } else {
                    sweetAlert("Oops...", "Fecha Desde y Hasta son campos obligatorios.", "error");
                }
            }
            ctrl.cargarDatos = function (tipo, data) {
                cargarDatos(tipo, data)
            }
            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.turnos = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                    swal.close();
                } else if (tipo == 'xls') {
                    var arrayObject = data.Data;
                    ctrl.arrayExport = [];
                    if (ctrl.esTelefonico) {

                        ctrl.arrayExport[0] = ['Id', 'Interesado', 'CUIL Interesado', 'Estado', 'Trámite', 'Agenda', 'Turno', 'Agente', 'Modalidad', 'Id Centro de Atención', 'Centro de Atención', 'Datos Particulares', 'Comentarios', 'Patente/Dominio'];
                        for (var i = 0; i < arrayObject.length; i++) {
                            console.log(arrayObject[i]);
                            ctrl.arrayExport[i + 2] = [
                                arrayObject[i].Id_Turno,
                                arrayObject[i].Interesado,
                                arrayObject[i].Cuil_Interesado,
                                arrayObject[i].Estado,
                                arrayObject[i].Tramite.trim() ? arrayObject[i].Tramite.trim() : '-',
                                arrayObject[i].N_Agenda,
                                moment(arrayObject[i].Turno).toDate().toLocaleString(),
                                arrayObject[i].Agente ? arrayObject[i].Agente : '-',
                                (ctrl.obtenerModalidad(arrayObject[i].Id_Modalidad)),
                                arrayObject[i].Id_Centro_Atencion,
                                arrayObject[i].N_Centro_Atencion,
                                arrayObject[i].Datos_Particulares,
                                arrayObject[i].Comentarios === null ? '-' : arrayObject[i].Comentarios,
                                arrayObject[i].Patente_Dominio || '-'
                            ]
                        }

                    } else {

                        ctrl.arrayExport[0] = [ctrl.centroAtencionSeleccionado.id, ctrl.centroAtencionSeleccionado.text];
                        ctrl.arrayExport[1] = ['Id', 'Interesado', 'CUIL Interesado', 'Estado', 'Trámite', 'Agenda', 'Turno', 'Agente', 'Modalidad', 'Fecha Solicitado', 'Datos Particulares', 'Comentarios', 'Patente/Dominio'];
                        for (var i = 0; i < arrayObject.length; i++) {
                            ctrl.arrayExport[i + 2] = [
                                arrayObject[i].Id_Turno,
                                arrayObject[i].Interesado,
                                arrayObject[i].Cuil_Interesado,
                                arrayObject[i].Estado,
                                arrayObject[i].Tramite.trim() ? arrayObject[i].Tramite.trim() : '-',
                                arrayObject[i].N_Agenda,
                                moment(arrayObject[i].Turno).toDate().toLocaleString(),
                                arrayObject[i].Agente ? arrayObject[i].Agente : '-',
                                (ctrl.obtenerModalidad(arrayObject[i].Id_Modalidad)),
                                moment(arrayObject[i].Fec_Solicitado).toDate().toLocaleString(),
                                arrayObject[i].Datos_Particulares,
                                arrayObject[i].Comentarios === null ? '-' : arrayObject[i].Comentarios,
                                arrayObject[i].Patente_Dominio || '-'
                            ]
                        }

                    }

                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Turnos',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            //funcion para devolver la modalidad para el excel.
            ctrl.obtenerModalidad = function (Id_Modalidad) {
                var result = "";
                if (Id_Modalidad == ctrl.Modalidades.Presencial) {
                    result = ctrl.ModalidadesArray.Presencial.Text;
                } else if (Id_Modalidad == ctrl.Modalidades.OnLine) {
                    result = ctrl.ModalidadesArray.OnLine.Text;
                } else if (Id_Modalidad == ctrl.Modalidades.Atencion_Telefonica) {
                    result = ctrl.ModalidadesArray.Atencion_Telefonica.Text;
                } else {
                    result = ctrl.ModalidadesArray.Orden_de_Llegada.Text;
                }
                return result;
            }

            ctrl.getData = function (item, page, limit, tipo, callback) {
                ctrl.getDataItem = item;
                utilsService.swalTitle('Buscando Turnos', 'info');
                ctrl.limpiarMemoria();
                ctrl.promise = turnosService.Get_Supervision({
                    'filtro.id_Centro_Atencion': ctrl.centroAtencionSeleccionado ? ctrl.centroAtencionSeleccionado.id : null,
                    'filtro.id_Turno': ctrl.BuscarporId ? item.Id_Turno : null,
                    'filtro.id_Agenda': item.Id_Agenda,
                    'filtro.id_Tramite_Relevado': item.Id_Tramite,
                    'filtro.id_Modalidad': item.Id_Modalidad,
                    'filtro.id_Estado': item.Id_Estado,
                    'filtro.Nro_documento': item.Identificador_Persona ? item.Identificador_Persona : null,
                    'filtro.fec_Desde': item.Fec_Desde,
                    'filtro.fec_Hasta': item.Fec_Hasta,
                    'filtro.nro_documento': item.Nro_Documento,
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.Mostrar_Turnos_Con_Comentarios': item.Mostrar_Turnos_Con_Comentarios
                }).$promise.then(function (data) {
                    ctrl.guardarFiltros(data.Paging, item)
                    callback(tipo, data);
                    swal.close();
                }).catch(function (error) {
                    swal.close();
                    utilsService.errores(error);
                });

            }

            ctrl.buscarIdTurno = function (item) {
                if (item.Id_Turno > 0) {
                    utilsService.swalTitle('Buscando Turno', 'info')
                    ctrl.BuscarporId = true;
                    //ctrl.BuscarporPersona = false;
                    ctrl.getData(item, ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
                } else {
                    utilsService.errores("ADV - Parece que algún campo del formulario de filtro no está completo para esta búsqueda. <br/> Verifica que el campo Id Turno no este vacío.")
                };
            };

            ctrl.guardarFiltros = function (item, fechas) {
                delete $localStorage.TurneroApp_ListadoImprimir;
                ctrl.parametrosFiltro = {
                    centroAtencion: ctrl.centroAtencionSeleccionado ? ctrl.centroAtencionSeleccionado : null,
                    filtro: {
                        id_Centro_Atencion: ctrl.centroAtencionSeleccionado ? ctrl.centroAtencionSeleccionado.id : null,
                        id_Agenda: item.Id_Agenda ? item.Id_Agenda : null,
                        id_Tramite_Relevado: item.Id_Tramite ? item.Id_Tramite : null,
                        id_Modalidad: item.Id_Modalidad ? item.Id_Modalidad : null,
                        id_Estado: item.Id_Estado ? item.Id_Estado : null,
                        fec_Desde: fechas.Fec_Desde,
                        fec_Hasta: fechas.Fec_Hasta,
                        nro_documento: item.Nro_Documento ? item.Nro_Documento : null,
                        id_Turno: item.Id_Turno ? item.Id_Turno : null,
                        total_turnos: item.Reg_Totales ? item.Reg_Totales : 0
                    }
                }
                $localStorage.TurneroApp_ListadoImprimir = angular.toJson(ctrl.parametrosFiltro);
            }

            ctrl.verDetalle = function (item) {
                ctrl.limpiarMemoria();
                ctrl.ctrlPadre.Id_Turno = item.Id_Turno;
                ctrl.ctrlPadre.turnoDetalles = true;
                ctrl.ctrlPadre.turnosConsulta = false;
            };

            ctrl.imprimirTurno = function (item) {
                $window.open('#!/reimprimir?Id_Turno=' + item.Id_Turno + '&Desde_Ciudadano=false', '_blank');
            }

            ctrl.imprimirCertificado = function(turno){
                const urlCertificado = `#!/certificado?Id_Turno=${turno.Id_Turno}`;
                $window.open(urlCertificado, '_blank');
            };

            ctrl.enviarMailCertificado = function(turno){
                utilsService.swalTitle('Enviando certificado', 'info');
                turnosService.enviarMailCertificado({ 'Id_Turno': turno.Id_Turno }).$promise.then(function (resultado) {
                    swal('Certificado enviado!', 'El certificado del turno fue enviado exitosamente.', 'success');
                }).catch(function (error) {
                    swal('Error al enviar certificado', '', 'error');
                });
            };

            ctrl.anunciarTurno = function (turno) {
                //if (turno.Permite_Anunciar == 1) {
                ctrl.funcionAnunciar(turno.Id_Turno)
                //} else {
                //    swal({
                //        title: 'Anunciar Turno',
                //        html: "El turno, supera el tiempo de restricción para anunciarse.<br/> ¿Desea continuar?",
                //        type: 'info',
                //        showCancelButton: true,
                //        confirmButtonColor: '#3085d6',
                //        cancelButtonColor: '#d33',
                //        confirmButtonText: 'Aceptar',
                //        cancelButtonText: 'Cancelar',
                //        allowEscapeKey: false,
                //        allowOutsideClick: false
                //    }).then(function () {
                //        ctrl.funcionAnunciar(turno.Id_Turno)
                //    }, function (error) {
                //        if (error != 'cancel') {
                //            swal.close();
                //            sweetAlert("Oops...", "No se ha podido seleccionar el espacio para el turno", "error");
                //        }
                //    });
                //}

            }

            ctrl.funcionAnunciar = function (Id_Turno) {
                utilsService.swalTitle('Anunciando Turno', 'info');
                turnosService.Put_Turno_Anunciar({
                    'id_turno': Id_Turno, 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                }).$promise.then(function (resultado) {
                    console.info("Desde el backend se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ".");
                    //actualizo este turno
                    /*signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                        hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, Id_Turno).then(function () {
                            console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + Id_Turno + ": " + err.toString());
                        });
                    });*/

                    swal.close();
                    swal({
                        title: 'Turno anunciado',
                        html: "El turno fue anunciado correctamente",
                        type: 'success',
                        confirmButtonColor: '#004b81',
                        confirmButtonText: 'Aceptar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function () {
                        ctrl.grillaReload();
                    });
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.imprimirListado = function () {

                if (ctrl.datosFiltroInfo != null) {

                    $localStorage.TurneroApp_ListadoImprimir ? $window.open('#!/imprimirListado/', '_blank') : '';
                }

            }

            ctrl.limpiarMemoria = function () {
                ctrl.detalleTurnoInfo = null;
                ctrl.turnosSeleccionados = [];
            }

            ctrl.cancelarTurnos = function () {

                if (ctrl.turnosSeleccionados.length > 0) {

                    motivosService.GetByTipoMotivo({
                        'id_tipo_motivo': TurneroAppConstant.TipoMotivos.Cancelacion_Agente
                    }).$promise.then(function (data) {

                        var opciones = [];
                        var combo = '';
                        if (data.length > 0) {
                            for (var i = 0; i < data.length; i++) {
                                var Indice = 0;
                                var valor = '';
                                var array = [];
                                angular.forEach(data[i], function (value, key) {
                                    if (key == 'id') {
                                        Indice = value;
                                    }
                                    if (key == 'text') {
                                        valor = value;
                                    }
                                });
                                opciones[Indice] = valor;
                            }
                        }

                        swal({
                            title: 'Cancelar turno',
                            html: "¿Confirma que desea cancelar los turnos seleccionados? <br/> Si es así, indíquenos el motivo de la cancelación: <br/> ",
                            type: 'warning',
                            input: 'select',
                            showCancelButton: true,
                            inputOptions: opciones,
                            confirmButtonColor: '#004b81',
                            cancelButtonColor: '#971b2f',
                            confirmButtonText: 'Aceptar'
                        }).then(function (input) {
                            utilsService.swalNotification('Cancelando turnos.', 'Aguarde un instante, se estan cancelando los turnos seleccionados.', 'info');
                            ctrl.CancelarTurnos.id_turnos = "";

                            //recorro primero el objeto principal y en el valido si el valor es diferente de 
                            angular.forEach(ctrl.turnosSeleccionados, function (obj, id) {

                                //valido que el objeto este seleccionado y no tenga false en el contenido
                                if (obj != false) {
                                    //valido el estado, si no fuese Agendado/Reagendado/Requiere_Reagendado, no se debe habilitar el boton cancelar.
                                    if (obj.Id_Estado != ctrl.Estados.Agendado && obj.Id_Estado != ctrl.Estados.Reagendado && obj.Id_Estado != ctrl.Estados.Requiere_reagendado) {
                                        ctrl.disabledCancelar = true;
                                    };
                                    ctrl.CancelarTurnos.id_turnos = ctrl.CancelarTurnos.id_turnos + obj.Id_Turno + ',';
                                };

                            });

                            if (ctrl.CancelarTurnos.id_turnos.length != 0) {
                                ctrl.CancelarTurnos.id_turnos.slice(0, -1);
                            }


                            ctrl.CancelarTurnos.id_motivo = input
                            turnosService.Put_Turno_Cancelar({
                                'id_turnos': ctrl.CancelarTurnos.id_turnos, 'id_motivo': ctrl.CancelarTurnos.id_motivo
                            }, function () {
                                swal.close();
                                swal('Turnos cancelados!', 'Los turnos seleccionados han sido cancelados.', 'success');
                                ctrl.grillaReload();
                            }, function (error) {
                                swal.close();
                                utilsService.errores(error)
                            });
                        }
                        );

                    }).catch(function (error) {
                        utilsService.errores(error);
                    })
                };
            }

            ctrl.openMailNotifications = function () {
                if (ctrl.turnosSeleccionados) {
                    ctrl.Id_Agenda = ctrl.turnosSeleccionados[0].Id_Agenda;
                    $mdDialog.show({
                        template: '<co-mail-notificaciones turnos="$ctrl.turnosSeleccionados" id-agenda="$ctrl.Id_Agenda" ></co-mail-notificaciones>',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: false, // Only for -xs, -sm breakpoints.,
                        //parent: $rootElement,
                        scope: $scope,
                        preserveScope: true
                    });
                } else {
                    utilsService.errores({
                        data: {
                            Message: 'ADV - Debe seleccionar por lo menos un turno para poder enviar notificaciones.'
                        }
                    })
                }

            }

            ctrl.openCambioEstadoFinal = function () {
                if (ctrl.turnosSeleccionados) {
                    if (!ctrl.centroAtencionSeleccionado) {
                        ctrl.CentroAte = {
                            id: ctrl.turnosSeleccionados[0].Id_Centro_Atencion,
                            text: ctrl.turnosSeleccionados[0].N_Centro_Atencion
                        }
                    } else {
                        ctrl.CentroAte = ctrl.centroAtencionSeleccionado
                    }
                    ctrl.Id_Agenda = ctrl.turnosSeleccionados[0].Id_Agenda;
                    $mdDialog.show({
                        template: '<co-cambiar-estados-finales turnos="$ctrl.turnosSeleccionados" id-agenda="$ctrl.Id_Agenda" centro-atencion-seleccionado= $ctrl.CentroAte ctrl-padre="$ctrl"></co-cambiar-estados-finales>',
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: false, // Only for -xs, -sm breakpoints.,
                        //parent: $rootElement,
                        scope: $scope,
                        preserveScope: true
                    });
                } else {
                    utilsService.errores({
                        data: {
                            Message: 'ADV - Debe seleccionar por lo menos un turno para poder cambiar el estado.'
                        }
                    })
                }

            }

            ctrl.reagendarTurnos = function () {
                if (ctrl.turnosSeleccionados.length > 0) {
                    motivosService.GetByTipoMotivo({
                        'id_tipo_motivo': TurneroAppConstant.TipoMotivos.Reagendado_Agente
                    }).$promise.then(function (data) {

                        var opciones = [];
                        var combo = '';
                        if (data.length > 0) {
                            for (var i = 0; i < data.length; i++) {
                                var Indice = 0;
                                var valor = '';
                                var array = [];
                                angular.forEach(data[i], function (value, key) {
                                    if (key == 'id') {
                                        Indice = value;
                                    }
                                    if (key == 'text') {
                                        valor = value;
                                    }
                                });
                                opciones[Indice] = valor;
                            }
                        }

                        swal({
                            title: 'Reagendar turno',
                            html: "¿Confirma que desea reagendar " + (ctrl.turnosSeleccionados.length > 1 ? "los turnos seleccionados" : "el turno seleccionado") + " ? <br/> Si es así, indíquenos el motivo del reagendado: <br/> ",
                            type: 'warning',
                            input: 'select',
                            showCancelButton: true,
                            inputOptions: opciones,
                            confirmButtonColor: '#004b81',
                            cancelButtonColor: '#971b2f',
                            confirmButtonText: 'Aceptar'
                        }).then(function (input) {
                            ctrl.ctrlPadre.Id_Motivo_Reagendado = input;
                            if (ctrl.turnosSeleccionados.length > 1) {
                                utilsService.swalNotification('Reagendando turnos.', 'Aguarde un instante, se estan reagendando los turnos seleccionados.', 'info');
                                var lista_turnos = '';
                                for (var i = 0; i < ctrl.turnosSeleccionados.length; i++) {
                                    lista_turnos = lista_turnos ? lista_turnos + ',' + ctrl.turnosSeleccionados[i].Id_Turno : ctrl.turnosSeleccionados[i].Id_Turno;
                                }
                                turnosService.Reagendar_Turnos_Multiple({
                                    'Id_Turnos': lista_turnos, 'Id_Motivo': input
                                }).$promise.then(function (data) {
                                    swal.close();
                                    swal({
                                        title: 'Se reagendo con exito',
                                        html: 'Se han reagendaron los turnos seleccionados correctamente.',
                                        type: 'success',
                                        allowEscapeKey: false,
                                        allowOutsideClick: false
                                    });
                                    ctrl.grillaReload();
                                }).catch(function (error) {
                                    swal.close();
                                    utilsService.errores(error);
                                });

                            } else {
                                ctrl.ctrlPadre.TurnoSeleccionado = ctrl.turnosSeleccionados[0];
                                ctrl.ctrlPadre.turnosConsulta = false;
                                ctrl.ctrlPadre.turnoDetalles = false;
                                ctrl.ctrlPadre.turnoReagendar = true;
                            }
                        }
                        );

                    }).catch(function (error) {
                        utilsService.errores(error);
                    })


                } else {
                    utilsService.errores({
                        data: {
                            Message: 'ADV - Debe seleccionar por lo menos un turno para poder cambiar el estado.'
                        }
                    })

                }
            }

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo) {
                utilsService.swalTitle('Exportando datos', 'info')
                ctrl.getData(ctrl.datosFiltroInfo, 1, ctrl.pagination.total, tipo, cargarDatos);

            }
            ctrl.Excel = {
                down: function () {
                },
            }

        }
    ],
    template: require('./turnos_lista.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnos_listaComponent.js